"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _Flex = _interopRequireDefault(require("../../../../../components/shared-components/Flex"));

var _utils = _interopRequireDefault(require("../../../../../utils"));

var _reactCsv = require("react-csv");

var _icons = require("@ant-design/icons");

var _form = _interopRequireDefault(require("./form"));

var _EllipsisDropdown = _interopRequireDefault(require("../../../../../components/shared-components/EllipsisDropdown"));

// import { useHistory } from 'react-router';
// const { Option } = Select;
var date = new Date();
var today = "".concat(date.getFullYear(), "-").concat(date.getMonth() + 1, "-").concat(date.getDate());
var time = "".concat(date.getHours(), ":").concat(date.getMinutes());
var header = [{
  label: "RM_code",
  key: "RM_code"
}, {
  label: "Student_Name",
  key: "Student_Name"
}, {
  label: "Token_Number",
  key: "Token_Number"
}, {
  label: "Date",
  key: "Date"
}, {
  label: "Reason",
  key: "Reason"
}, {
  label: "WhatsApp_Number",
  key: "WhatsApp_Number"
}, {
  label: "Calling_Number",
  key: "Calling_Number"
}];

var CardData = function CardData(_ref) {
  var data = _ref.data;
  var avatarSize = 50; // const history = useHistory();
  // const cl = localStorage.getItem("CL");
  // const token = localStorage.getItem("token");

  var _useState = (0, _react.useState)(true),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0, _react.useState)({}),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      formDetail = _useState4[0],
      setFormDetail = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      isFormVisible = _useState6[0],
      setIsFormVisible = _useState6[1];

  var _useState7 = (0, _react.useState)(null),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      formType = _useState8[0],
      setFormType = _useState8[1];

  var _useState9 = (0, _react.useState)(data),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      tableData = _useState10[0],
      setTableData = _useState10[1];

  var csvRport = {
    filename: "\"DropOutRequest Data\" + \" \" + ".concat(today, " + \" \" + ").concat(time),
    headers: header,
    data: data
  }; // useEffect(async () => {
  //     setTableData(data);
  //     setLoading(false);
  // }, [data]);

  (0, _react.useEffect)(function () {
    function fetchData() {
      return _fetchData.apply(this, arguments);
    }

    function _fetchData() {
      _fetchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setTableData(data);
                setLoading(false);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _fetchData.apply(this, arguments);
    }

    fetchData();
  }, [data]); // const onDropClick=(value,str)=>{
  //     setFormDetail(value);
  //     setIsFormVisible(true);
  //     setFormType(str)
  // }
  // const dropdownMenu = elm => (
  //   <Menu>
  //     <Menu.Item>
  //       <Flex alignItems="center">
  //           <span className="ml-2" onClick={()=>onDropClick(elm,"DontDrop")} style={{color:'green'}}><PlusCircleOutlined style={{color:'green'}} className='mr-1'/>Don't Drop</span>
  //       </Flex>
  //     </Menu.Item>
  //     <Menu.Item>
  //       <Flex alignItems="center">
  //           <span className="ml-2" onClick={()=>onDropClick(elm,"Drop")} style={{color:'red'}}> <MinusCircleOutlined style={{color:'red'}} className='mr-1'/>Drop</span>
  //       </Flex>
  //     </Menu.Item>
  //   </Menu>
  // );

  var dropdownMenu = function dropdownMenu(elm) {
    return /*#__PURE__*/_react.default.createElement(_antd.Menu, null, /*#__PURE__*/_react.default.createElement(_antd.Menu.Item, null, /*#__PURE__*/_react.default.createElement(_Flex.default, {
      alignItems: "center"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "ml-2",
      onClick: function onClick() {
        return onDropClick(elm, "DontDrop");
      },
      style: {
        color: 'green'
      }
    }, /*#__PURE__*/_react.default.createElement(_icons.PlusCircleOutlined, {
      style: {
        color: 'green'
      },
      className: "mr-1"
    }), "Don't Drop"))), /*#__PURE__*/_react.default.createElement(_antd.Menu.Item, null, /*#__PURE__*/_react.default.createElement(_Flex.default, {
      alignItems: "center"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "ml-2",
      onClick: function onClick() {
        return onDropClick(elm, "Drop");
      },
      style: {
        color: 'red'
      }
    }, " ", /*#__PURE__*/_react.default.createElement(_icons.MinusCircleOutlined, {
      style: {
        color: 'red'
      },
      className: "mr-1"
    }), "Drop"))));
  };

  var onDropClick = function onDropClick(value, str) {
    setFormDetail(value);
    setIsFormVisible(true);
    setFormType(str);
  };

  return loading ? /*#__PURE__*/_react.default.createElement(_antd.Spin, {
    tip: "loading"
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isFormVisible ? /*#__PURE__*/_react.default.createElement(_form.default, {
    formDetail: formDetail,
    formType: formType,
    isFormVisible: isFormVisible,
    onOk: function onOk() {
      return setIsFormVisible(true);
    },
    onCancel: function onCancel() {
      return setIsFormVisible(false);
    }
  }) : null, /*#__PURE__*/_react.default.createElement(_antd.Card, {
    title: "Drop Out Requests",
    style: {
      'fontSize': '5px',
      backgroundColor: '#f5f5f5'
    },
    extra: /*#__PURE__*/_react.default.createElement(_reactCsv.CSVLink, csvRport, /*#__PURE__*/_react.default.createElement(_icons.DownloadOutlined, {
      style: {
        'fontSize': 30
      }
    }))
  }, tableData.map(function (stu, index) {
    return /*#__PURE__*/_react.default.createElement(_antd.Card, {
      key: index
    }, /*#__PURE__*/_react.default.createElement(_antd.Row, {
      justify: "center"
    }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 24,
      xl: 24,
      xxl: 24
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "d-flex"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "rounded p-2 bg-white shadow-sm mx-auto",
      style: {
        'marginTop': '-2.0rem',
        'maxWidth': "".concat(avatarSize + 16, "px"),
        'maxHeight': '70px'
      }
    }, /*#__PURE__*/_react.default.createElement(_antd.Avatar, {
      className: "font-size-sm",
      style: {
        backgroundColor: '#04d182'
      },
      size: avatarSize
    }, _utils.default.getNameInitial(stu.Student_Name))), /*#__PURE__*/_react.default.createElement("div", {
      className: "ml-md-4 w-100"
    }, /*#__PURE__*/_react.default.createElement(_Flex.default, {
      alignItems: "center",
      mobileFlex: false,
      className: "mb-3 text-md-left text-center"
    }, /*#__PURE__*/_react.default.createElement("h2", {
      className: "mb-0"
    }, stu.Student_Name))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_EllipsisDropdown.default, {
      menu: dropdownMenu(stu)
    }))), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
      xxl: 12
    }, /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 12,
      sm: 12,
      md: 12,
      lg: 12,
      xl: 12,
      xxl: 12
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "text-muted ml-1"
    }, "Token No")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 12,
      sm: 12,
      md: 12,
      lg: 12,
      xl: 12,
      xxl: 12
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "font-weight-semibold"
    }, stu.Token_Number ? stu.Token_Number : "No Data")))), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
      xxl: 12
    }, /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 12,
      sm: 12,
      md: 12,
      lg: 12,
      xl: 12,
      xxl: 12
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "text-muted ml-1"
    }, "RM Code")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 12,
      sm: 12,
      md: 12,
      lg: 12,
      xl: 12,
      xxl: 12
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "font-weight-semibold"
    }, stu.RM_Code ? stu.RM_Code : "No Data")))), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 24,
      xl: 24,
      xxl: 24
    }, /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 12,
      sm: 12,
      md: 12,
      lg: 12,
      xl: 12,
      xxl: 12
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "text-muted ml-1"
    }, "Date")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 12,
      sm: 12,
      md: 12,
      lg: 12,
      xl: 12,
      xxl: 12
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "font-weight-semibold"
    }, stu.Date ? stu.Date : "No Data")))), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 24,
      xl: 24,
      xxl: 24
    }, /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 12,
      sm: 12,
      md: 12,
      lg: 12,
      xl: 12,
      xxl: 12
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "text-muted ml-1"
    }, "WhatsApp No")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 12,
      sm: 12,
      md: 12,
      lg: 12,
      xl: 12,
      xxl: 12
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "font-weight-semibold"
    }, stu.WhatsApp_Number ? stu.WhatsApp_Number : "No Data")))), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 24,
      xl: 24,
      xxl: 24
    }, /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 12,
      sm: 12,
      md: 12,
      lg: 12,
      xl: 12,
      xxl: 12
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "text-muted ml-1"
    }, "Calling No")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 12,
      sm: 12,
      md: 12,
      lg: 12,
      xl: 12,
      xxl: 12
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "font-weight-semibold"
    }, stu.Calling_Number ? stu.Calling_Number : "No Data")))), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 24,
      xl: 24,
      xxl: 24
    }, /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 12,
      sm: 12,
      md: 12,
      lg: 12,
      xl: 12,
      xxl: 12
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "text-muted ml-1"
    }, "Reason")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 12,
      sm: 12,
      md: 12,
      lg: 12,
      xl: 12,
      xxl: 12
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "font-weight-semibold"
    }, stu.Reason ? stu.Reason : "No Data")))))));
  })));
};

var _default = CardData;
exports.default = _default;